import { useQuery } from "react-query";
import { UIViewEnum } from "../../common/enums/UIViewEnum";
import { IeLynxObject } from "../../common/models/eLynxObject";
import NavigationDataService from "../../services/navigation-data-service/NavigationDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseAvailableViewsParameters = {
    customerID: number,
    groupID: number,
    contextObject?: IeLynxObject,
} & BaseUseQueryParameters<Array<UIViewEnum> | undefined>;

export function useAvailableViews({
    customerID,
    groupID,
    contextObject,
    offline,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseAvailableViewsParameters) {
    return useQuery<Array<UIViewEnum>, RestError>(
        keys.list(customerID, groupID, contextObject, offline),
        ({ signal }) => {
            return NavigationDataService.getAvailableViews(
                customerID,
                groupID,
                contextObject as IeLynxObject,
                offline ?? false,
                signal
            );
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds  * 1000 : false,
            keepPreviousData: true
        }
    );
}
